module.exports = __webpack_public_path__ + "img/Radiation Theraphy.7d89d11.png";